import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

export const InviteCode = ({ optional, ...props }: InputComponentProps) => {
  const validate = ({ value }) => {
    if (value.length < 1) return 'Please enter a valid invite code!';
    return true;
  };

  return (
    <ValidatingInput
      label="Did you get an invite code? If so, add it here."
      name="inviteCode"
      optional={optional}
      validate={validate}
      {...props}
    />
  );
};
